import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Pages
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import JourneySelectPage from './pages/JourneySelectPage';
import JourneyMapPage from './pages/JourneyMapPage';
import AdminPage from './pages/AdminPage';

const NotFound: React.FC = () => (
  <div style={{ padding: '4rem 2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
    <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem', color: '#1e293b' }}>404</h1>
    <p style={{ color: '#64748b', marginBottom: '1.5rem' }}>Stránka nebyla nalezena.</p>
    <a
      href="/"
      style={{
        color: '#4f46e5',
        textDecoration: 'none',
        fontWeight: 600,
        padding: '0.5rem 1rem',
        border: '1px solid #4f46e5',
        borderRadius: '0.5rem',
      }}
    >
      Zpět na úvod
    </a>
  </div>
);

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Auth flows */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />

        {/* Main app */}
        <Route path="/journey-select" element={<JourneySelectPage />} />
        <Route path="/journey/:type" element={<JourneyMapPage />} />
        <Route path="/admin" element={<AdminPage />} />

        {/* Legacy redirects (bývalé krisspy routy) */}
        <Route path="/path-selection" element={<Navigate to="/journey-select" replace />} />
        <Route path="/journey-mapping" element={<Navigate to="/journey/customer" replace />} />

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
